import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

// this will reused for single and multiple selection
// we will handle still an array answer but we will transfor to string if not multiple
export default function WebSelectSVGRect({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [availableChoices, setAvailableChoices] = useState(data?.choices);

    const [answer, setAnswer] = useState([]);

    useEffect(() => {
        setAvailableChoices(data?.choices);
        setAnswer([]);
    }, [question,
        data?.choices
    ]);

    const handleChoiceClick = (choice) => {
        let ans = [...answer];
        if (ans.indexOf(choice.value) > -1) {
            removeChoice(choice.value);
        } else {
            if (!(data?.multiple) && ans.length > 0) { // single if not exist set to empty
                setAnswer([]);
                ans = [];
            }

            ans = [
                ...ans,
                choice.value,
            ];

            setAnswer(ans);
            checkCanProceed(ans);
        }
    }

    const removeChoice = (value) => {
        let newAnswer = [...answer];
        let index = newAnswer.indexOf(value)
        if (index !== -1) {
            newAnswer.splice(index, 1);
            setAnswer(newAnswer);
        }

        checkCanProceed(newAnswer);
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;

        const finalAnswer = data?.multiple ? ans : (ans[0] ?? "");

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    return (
        <Box
            sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                userSelect: "none",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                }}
            >
                <Box component="img" src={`${imagesResources}${data?.image}`} alt="Img"/>
                <svg width="101%" 
                    height="100%" 
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                >
                    {availableChoices.map((choice, index) => (
                        <React.Fragment key={index}>
                            {typeof choice.rect != "undefined" && (
                                <rect
                                    style={{ 
                                            textAlign: "center",
                                        }}
                                    fill={answer.includes(choice.value) ? "rgba(255, 217, 102, 0.75)" : "transparent"}
                                    stroke={answer.includes(choice.value) ? "#ffc000" : "none"}
                                    strokeWidth="3"
                                    data-value={choice.value}
                                    onMouseOver={(event) => {event.target.style.cursor = 'pointer'}}
                                    x={choice.rect.x}
                                    y={choice.rect.y}
                                    width={choice.rect.width}
                                    height={choice.rect.height}
                                    onClick={() => handleChoiceClick(choice)}
                                ></rect>
                            )}
                            {typeof choice.circle != "undefined" && (
                                <circle
                                    style={{ 
                                            textAlign: "center",
                                        }}
                                    fill={answer.includes(choice.value) ? "rgba(255, 217, 102, 0.75)" : "transparent"}
                                    stroke={answer.includes(choice.value) ? "#ffc000" : "none"}
                                    strokeWidth="3"
                                    data-value={choice.value}
                                    onMouseOver={(event) => {event.target.style.cursor = 'pointer'}}
                                    cx={choice.circle.cx}
                                    cy={choice.circle.cy}
                                    r={choice.circle.r}
                                    onClick={() => handleChoiceClick(choice)}
                                ></circle>
                            )}
                        </React.Fragment>
                    ))}
                </svg>
            </Box>
        </Box>
    );
};